/**************************************************
 * Nombre:       Dialogo_Funnel
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {Check} from '@mui/icons-material'
import {guardarObjLocal} from "../../Servicios/Local/guardarObjLocal";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import Formulario_Funnel from "../Formularios/Formulario_Funnel";
import {obtenerIDLocal} from "../../Modulo_Analiticas_Local/Funciones/obtenerIDLocal";
import {useEffect} from "react";
import {obtenerObjLocal} from "../../Servicios/Local/obtenerObjLocal";
import {obtenerParametrosUrl} from "../../CodigoCliente/Funciones/obtenerParametrosUrl";
import {obtenerNumeroWass} from "../../Modulo_formularios/Funciones/obtenerNumeroWass";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {enviarPeticion} from "../../Modulo_Peticiones/Peticiones/enviarPeticion";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Felicitaciones from "./Dialogo_Felicitaciones";


const Dialogo_Funnel = ({datos, cerrar, realizado}) => {
    const {sCell} = useResponsive()
    const {
        props,
        obtenerEntidad,
        setEntidad
    } = useFormulario({valoresDefecto: {}})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga, cerrarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Felicitaciones, realizado: realizado})


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        let id = obtenerIDLocal()
        entidad.id = id + '-' + datos.nombre.replaceAll(' ', '-')
        entidad.idUsuario = obtenerParametrosUrl({clave: 'idUsu'})
        entidad.idFunnel = obtenerParametrosUrl({clave: 'id'})
        entidad.nombreFunnel = datos.nombre
        entidad.estado = 'Nuevo'
        entidad.numero = datos.numero
        iniciarCarga('Registrando progreso')

        let dox = await guardarDoc('leads', entidad)
        if (dox.res) {

            guardarObjLocal({key: 'lead', obj: {...entidad, id: dox.data}})
            guardarObjLocal({key: datos.nombreFunnel, obj: {paso: 2, id: dox.data}})

            await enviarNotificacion({
                idFunnel: entidad.idFunnel, idUsuario: entidad.idUsuario, entidad: entidad
            })
            if (verifiacarSiUltimoVideo(entidad.idFunnel)) {

                cerrarCarga()
                abrir(datos)
            } else {
                cerrar()
                realizado()
                terminar({aviso: 'Datos subidos con exito'})
            }


        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }

        cerrarCarga()

    }

    const verifiacarSiUltimoVideo = (idFunnel) => {

        let paso = obtenerObjLocal({key: 'paso' + idFunnel})
        if (!paso) return false

        if (paso.paso >= 2) {
            return true
        } else {
            return false
        }


    }

    const enviarNotificacion = async ({idFunnel, idUsuario, entidad}) => {

        let celular = obtenerNumeroWass({numero: entidad.celular, pais: entidad.pais})
        entidad.celular = celular

        let wheres = [where('idFunnel', '==', idFunnel), where('idUsuario', '==', idUsuario)]

        let dox = await obtenerColWheres({col: 'campanas', wheres: wheres})
        if (dox.res && dox.data && dox.data[0]) {
            await enviarPeticion({datos: {...dox.data[0], lead: entidad}, flujo: 'notificacion'})
        }


    }


    useEffect(() => {
        let lead = obtenerObjLocal({key: 'lead'})

        if (lead) {
            setEntidad(lead)
        }

    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Dialogo/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: -4}}>
                <Typography sx={{
                    fontSize: sCell ? 24 : 24,
                    fontWeight: 600,
                    color: '#1B0B3B',
                    textTransform: 'uppercase',
                    lineHeight: 1.2,
                    textAlign: 'center'
                }}>
                    {datos.tituloFormulario} <span
                    style={{color: '#9049F5'}}> {datos.rosadoTituloFormulario} </span>

                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Typography sx={{color: "#000", fontWeight: 300, fontSize: 14, textAlign: 'center', lineHeight: 1.3}}>
                    {datos.parrafoFormulario}
                </Typography>
            </Grid>
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 3}}>
                <Formulario_Funnel props={props} datosFormulario={datos.datosFormulario}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                    startIcon={<Check/>}
                >Continuar Aprendizaje</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Funnel